export const parseTask = task => ( {
	...task,
	author: task.author.id,
	responsibles: task.responsibles.map( ( { id } ) => id )
} );
